'use client';
import { SmartChat, Theme } from '@mfrm/design-library';

const SmartChatComponent: React.FC = ({}) => {
  return (
    <Theme>
      <SmartChat className="mobile-hidden" />
    </Theme>
  );
};

export default SmartChatComponent;
